import paths from './paths/index.js';

export default {
  path: paths,
};